/* eslint-disable react/no-array-index-key */
import { Row, Col, Container } from 'react-bootstrap';
import {
  HeadingWithSpaceLarge,
  SectionInnerHeading
} from '../../../Components/Headings';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import addIcon from '../../../assets/images/svg/plus-white.svg';
import './addFamilyMember.css';
import { SimpleAncerSmall } from '../../../Components/button';

function AddFamilyMember() {
  return (
    <HealthCheckLayout>
      <section className="addFamilyMember bgLinghtGray">
        <Container>
          <div className="addBox">
            <HeadingWithSpaceLarge text="ADD FAMILY MEMBERS" />
          </div>
          <Row>
            <Col md={5}>
              <div className="me-5">
                <SectionInnerHeading text="No family member has been added yet!" />
                <SimpleAncerSmall
                  to="/editFamilyMember"
                  text="ADD FAMILY MEMBER HERE"
                >
                  <img src={addIcon} alt="addIcon" />
                </SimpleAncerSmall>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default AddFamilyMember;
